import React, { useEffect } from "react";
import { Lightbox, CloseButton } from "./design";

const PhotoLightbox = ({ src, onClose }) => {
    useEffect(() => {
        if (!src) return;
        const handler = e => { if (e.key === "Escape") onClose(); };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [src, onClose]);

    if (!src) return null;
    return (
        <Lightbox role="dialog" aria-modal="true" aria-label="Fotoansicht" onClick={onClose}>
            <CloseButton type="button" onClick={onClose} aria-label="Schließen">×</CloseButton>
            <img src={src} alt="Foto" onClick={e => e.stopPropagation()} />
        </Lightbox>
    );
};
export default PhotoLightbox;
